import {Suspense} from 'react';
import {lazyWithRetry} from 'src/utils/lazyWithRetry';
import {Outlet} from 'react-router-dom';
// auth
import {AuthGuard} from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import {LoadingScreen} from 'src/components/loading-screen'

const NomenclaturesPage = lazyWithRetry(() => import('src/pages/nomenclatures/NomenclaturesPage'));

export const nomenclaturesRoutes = [
  {
    path: '/nomenclatures',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      {
        index: true,
        element: <NomenclaturesPage />,
      },
      {
        path: 'view/:id',
        element: <NomenclaturesPage />,
      },
    ],
  },
];
